import {
  FETCHING_SHARE_SECTION_REQUEST, FETCHING_SHARE_SECTION_SUCCEDDED, FETCHING_SHARE_SECTION_FAILED,
  ADD_ASSETS_TO_SHARE_SECTION, ADD_ASSETS_TO_SHARE_SECTION_SUCCEDDED, ADD_ASSETS_TO_SHARE_SECTION_FAILED
} from './actionTypes';

import axios from 'axios';
import buildUrl from 'build-url-ts';
const apiUrl = `${process.env.REACT_APP_API_URL}`;


const SHARE_BASE_URL = `${apiUrl}/api/2.0/shares`;
const SHARE_SECTION_URL = `${SHARE_BASE_URL}/sections`;

/**
* Fetch share section for given id
*/
export function fetchShareSection(shareId, sectionId, type) {
  return function (dispatch) {
    dispatch(fetchingShareSection(shareId, sectionId));

    let url = buildUrl(SHARE_BASE_URL, {
      path: `/sections/${sectionId}`
    });

    var params = {
      type: type
    }


    return axios({
      method: 'GET',
      url: url,
      params: params
    })
      .then(response =>
        dispatch(fetchingShareSectionSuccedded(shareId, response.data))
      )
      .catch(error =>
        dispatch(fetchingShareSectionFailed(shareId, sectionId, error))
      )
  }
}

function fetchingShareSection(shareId, sectionId) {
  return {
    type: FETCHING_SHARE_SECTION_REQUEST,
    payload: {
      id: shareId,
      section: sectionId
    }
  }
}

function fetchingShareSectionSuccedded(shareId, json) {
  return {
    type: FETCHING_SHARE_SECTION_SUCCEDDED,
    payload: {
      id: shareId,
      section: json
    }
  }
}

function fetchingShareSectionFailed(shareId, sectionId, error) {
  return {
    type: FETCHING_SHARE_SECTION_FAILED,
    payload: {
      id: shareId,
      sectionId: sectionId,
      error: error
    }
  }
}


/**
* Add Asset to Share Section
*/
export function addAssetToSection(id, section, assets) {
  return function (dispatch) {
    dispatch(addingAssetToSection(id, section));

    let url = buildUrl(SHARE_SECTION_URL, {
      path: `${section}/assets`
    });

    return axios({
      method: 'PUT',
      url: url,
      data: assets
    })
      .then(response =>
        dispatch(addingAssetToSectionSuccedded(id, section, response.data))
      )
      .catch(error =>
        dispatch(addingAssetToSectionFailed(id, section, error))
      )
  }
}

function addingAssetToSection(id, section) {
  return {
    type: ADD_ASSETS_TO_SHARE_SECTION,
    payload: {
      id: section,
      collectionId: id
    }
  }
}

function addingAssetToSectionSuccedded(id, section, json) {
  return {
    type: ADD_ASSETS_TO_SHARE_SECTION_SUCCEDDED,
    payload: {
      id: section,
      collectionId: id,
      section: json
    }
  }
}

function addingAssetToSectionFailed(id, section, error) {
  console.log(error);
}